import React from "react";

const PreviewContext = React.createContext(null);

export default PreviewContext;
